module.exports = "/static/assets/8279ce395d0333b880b8be6d243fd111.svg";